/**
 * SunIcon — ícone de sol "clássico" (círculo preenchido + raios retos).
 *
 * Por quê existe: o `faSun` do FontAwesome 6 (free-solid-svg-icons) foi
 * redesenhado com um contorno recortado/ondulado e um ANEL (círculo vazado)
 * no centro em vez de um disco preenchido — em tamanhos pequenos (como o
 * botão de tema, ~15px) isso lê visualmente como uma engrenagem/ícone de
 * configurações, não como um sol. Substituído por este SVG simples com o
 * desenho tradicional (disco cheio + 8 raios), que fica inequívoco mesmo
 * pequeno. Ver docs/07-issues.md.
 *
 * Props espelham o suficiente de FontAwesomeIcon pros call sites existentes
 * não precisarem mudar nada além do import: herda cor via `currentColor` e
 * tamanho via `1em` (mesmo padrão usado pelos outros ícones FA no app).
 */
export default function SunIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ verticalAlign: "-0.125em" }}
      aria-hidden="true"
      {...props}
    >
      <circle cx="12" cy="12" r="4.5" fill="currentColor" stroke="none" />
      <line x1="12" y1="1.5" x2="12" y2="4.5" />
      <line x1="12" y1="19.5" x2="12" y2="22.5" />
      <line x1="1.5" y1="12" x2="4.5" y2="12" />
      <line x1="19.5" y1="12" x2="22.5" y2="12" />
      <line x1="4.4" y1="4.4" x2="6.5" y2="6.5" />
      <line x1="17.5" y1="17.5" x2="19.6" y2="19.6" />
      <line x1="4.4" y1="19.6" x2="6.5" y2="17.5" />
      <line x1="17.5" y1="6.5" x2="19.6" y2="4.4" />
    </svg>
  );
}
